"use strict";

var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
const _excluded = ["accessList", "data", "from", "gas", "gasPrice", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "to", "value"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendUnsignedTransaction = void 0;
const extract_js_1 = require("../../utils/formatters/extract.js");
const transactionRequest_js_1 = require("../../utils/formatters/transactionRequest.js");
async function sendUnsignedTransaction(client, args) {
  var _client$chain;
  const {
      accessList,
      data,
      from,
      gas,
      gasPrice,
      maxFeePerGas,
      maxPriorityFeePerGas,
      nonce,
      to,
      value
    } = args,
    rest = _objectWithoutProperties(args, _excluded);
  const chainFormat = (_client$chain = client.chain) === null || _client$chain === void 0 || (_client$chain = _client$chain.formatters) === null || _client$chain === void 0 || (_client$chain = _client$chain.transactionRequest) === null || _client$chain === void 0 ? void 0 : _client$chain.format;
  const format = chainFormat || transactionRequest_js_1.formatTransactionRequest;
  const request = format(_objectSpread(_objectSpread({}, (0, extract_js_1.extract)(rest, {
    format: chainFormat
  })), {}, {
    accessList,
    data,
    from,
    gas,
    gasPrice,
    maxFeePerGas,
    maxPriorityFeePerGas,
    nonce,
    to,
    value
  }));
  const hash = await client.request({
    method: 'eth_sendUnsignedTransaction',
    params: [request]
  });
  return hash;
}
exports.sendUnsignedTransaction = sendUnsignedTransaction;
//# sourceMappingURL=sendUnsignedTransaction.js.map